var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLkwSchwarz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 39.79 21.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg4993"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5868",
    d: "M26.52,0C19.57,0,13.8,0,13.69,0a.81.81,0,0,0-.36.2L13.17.4v13H12.09l0-4.89c0-4.62,0-4.91-.14-5.08-.24-.36-.24-.36-3.57-.13a42,42,0,0,0-5,.45,1.51,1.51,0,0,0-1.11.8c-.08.15-.63,1.54-1.22,3.08a21,21,0,0,0-1.07,3c0,.13.07.84.14,1.57s.16,2.07.19,3c.07,1.69.11,2,.33,2.27a1.58,1.58,0,0,0,1.12.34l.27,0,.11.36a4.13,4.13,0,0,0,2.15,2.48,3.86,3.86,0,0,0,3.5-.09,4.12,4.12,0,0,0,2-2.5c.1-.41.13-.46.25-.43.72.22,1,.23,8.67.21l7.52,0,.13.53a3.87,3.87,0,0,0,1,1.72,4.06,4.06,0,0,0,2.31,1.18,3.94,3.94,0,0,0,2.5-.52,3.67,3.67,0,0,0,1.32-1.25,4.52,4.52,0,0,0,.64-1.52c0-.08.19-.1,1.26-.12l1.27,0,1.22-.4c1.43-.48,1.64-.58,1.77-.82a8.28,8.28,0,0,0,0-2.57c-.09-.32-.09-.35,0-.52s.11-.56.13-6.51c0-7,0-6.7-.4-6.89C39.19,0,37.47,0,26.52,0ZM7.6,6.14l0,1.51c0,.84,0,1.53-.05,1.55s-1.06.15-2.31.29-2.34.27-2.42.29H2.65c0-.11,1.18-3.28,1.25-3.35a19.68,19.68,0,0,1,2.61-.24L7.6,6.14ZM6,14.19A2.76,2.76,0,1,1,3.21,17,2.76,2.76,0,0,1,6,14.19Zm24.26.41a2.76,2.76,0,1,1-2.75,2.75A2.75,2.75,0,0,1,30.23,14.6Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLkwSchwarz);
export default __webpack_public_path__ + "static/media/icon_lkw_schwarz.ea70523f4efdb5a49804a8e95eec86e9.svg";
export { ForwardRef as ReactComponent };